<template>
  <div class="common-form" :class="type === 'dark' ? 'dark' : 'light'">
<!--    <product-select @select="handleSelectProduct" v-if="showProductSelect"></product-select>-->
    <van-field placeholder="请填写姓名" label="姓名" required v-model="form.realName"></van-field>
    <van-field placeholder="请填写手机号码" label="手机号码" required v-model="form.mobile" @focus="hideError">
      <template slot="right-icon">
        <span class="error-message" v-show="phoneFormatError">格式错误</span>
      </template>
    </van-field>
     <van-field placeholder="请填写邮箱" label="邮箱" v-model="form.email"/>
    <van-field placeholder="请填写公司信息" label="公司名称" required v-model="form.companyName"></van-field>
    <area-select :isLineFeed="true" placeholder="请选择公司所在地区" label="公司所在地" required @select="handleSelectArea"></area-select>
    <!-- <van-field placeholder="请填写数量" class="rooms" label="企业会议室数量" type="number" required v-model="form.rooms"/>
    <van-field placeholder="请填写会议难题"  label="目前面临的会议难题" type="text"  v-model="form.puzzle"/> -->
    <!-- <div class="radio-title">
      * 选择的赠送品（单选）
    </div>
    <el-radio-group class="el-group" v-model="form.radio">
      <el-radio-button label="MAXHUB 65英寸会议平板（软硬兼容）" />
      <el-radio-button label="MAXHUB x 腾讯会议Rooms专款" />
      <el-radio-button label="MAXHUB x 飞书软件会员" />
    </el-radio-group> -->
    <van-checkbox shape="square" icon-size="14px" v-model="form.checked">
      <span class="news-rules">我已阅读并理解<router-link class="link" :to="{name: 'rules', query: {isNewsRules: true}}">《活动规则》</router-link></span>
    </van-checkbox>
    <van-checkbox shape="square" icon-size="14px" v-model="form.privacy">
      <span class="news-rules">我已理解并同意按照<router-link class="link" :to="{name: 'rules', query: {isPrivacy: true}}"> 隐私保护条款 </router-link>使用和传递我的个人信息</span>
    </van-checkbox>
    <div class="rol2">
      标记*为必填项。<span class="tips">申请仅限企业用户。</span><br>
      <span>为不影响您获得试用的机会，请务必准确填写并核对信息，我们将通过电话方式与您联系。</span>
    </div>
    <submit-button :class="isTable ? 'form-btn' : ''" :isNewsForm="true" :checked="form.checked"  @click="submitForm" :disabled="buttonDisbled" :loading="submitLoading"></submit-button>
  </div>
</template>

<script>
import FormMixins from '@mixins/form-mixins';
export default {
  name: 'NewsForm',
  mixins: [FormMixins],
  props: {
    type: { // 有两种值，dark和light，dark则表单的文字是黑灰色，light则表单的文字是白色
      type: String,
      default: 'light'
    },
    showProductSelect: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      radio1: '1'
    }
  },
  created () {
    this.$store.commit("setIsNewsForm", true);
  }
}
</script>
<style lang="scss">
.el-group {
    display: block !important;
    width: 91%;
    margin: auto;
    padding: 0.5rem 1rem;
    .el-radio-button {
      display: block !important;
      padding-bottom: 0.6rem;
      .el-radio-button__inner {
        display: block;
        border: none !important;
        color: #969799;
        padding: 16px 20px;
        text-align: left;
        background-color: rgb(246, 247, 248) !important;
      }
    }
    .is-active {
      .el-radio-button__inner {
        box-shadow: none;
        -webkit-box-shadow: none;
        color: #EC691A;
      }
    }
  }
</style>
<style lang="scss" scoped>
@import './NewsForm.scss';
</style>
